export default __webpack_public_path__ + "static/media/E15.a5e681fd.jpg";